import { FC } from 'react'
import styles from 'components/features/future/FutureFieldControl/FutureFieldControlButtons.styl'
import cn from 'classnames'

type FutureFieldControlButtonsProps = {
  isDisabled: boolean
  onIncrement: () => void
  onDecrement: () => void
}
export const FutureFieldControlButtons: FC<FutureFieldControlButtonsProps> = (props) => {
  const { isDisabled, onIncrement, onDecrement } = props

  return (
    <div className={ cn(styles.futureFieldControlButtons, isDisabled && styles.disabled) }>
      <button
        className={ styles.button }
        type='button'
        disabled={ isDisabled }
        onClick={ onDecrement }
        tabIndex={ -1 }
      >–
      </button>
      <button
        className={ styles.button }
        type='button'
        disabled={ isDisabled }
        onClick={ onIncrement }
        tabIndex={ -1 }
      >+
      </button>
    </div>
  )
}
